import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { UConductWorkspaceComp } from "userful-chronos-app-common-js/dist/models/uconduct/View";
import UserfulTooltip from "../../Widgets/UserfulTooltip";
import { requestRemoveUConductWorkspace } from "userful-chronos-app-common-js/dist/models/uconduct/messages/uConductViewMsgSender";
import Button from "../../button/Button";
import { faCircleExclamation, faTrashAlt } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";
import UserfulConfirmationDialog from "../../ConfirmationDialog/UserfulConfirmationDialog";

interface IProps {
    workspace: UConductWorkspaceComp;
    onAction?: () => void;
    onTheTable?: boolean;
    open?: boolean;
    onOpenChange?: (open: boolean) => void;
    hideTrigger?: boolean;
}

export default function WorkspaceDelete({ workspace, onTheTable, onAction, open, onOpenChange, hideTrigger }: IProps) {
    const isControlled = open !== undefined;
    const [showInternal, setShowInternal] = useState<boolean>(false);
    const showConfirmation = isControlled ? !!open : showInternal;

    const { t } = useTranslation();

    const setShowState = (next: boolean) => {
        if (isControlled) {
            onOpenChange?.(next);
        } else {
            setShowInternal(next);
        }
    };

    return (
        <>
            {!hideTrigger && !onTheTable && (
                <UserfulTooltip title={"Delete Workspace"} placement="bottom">
                    <Button
                        iconOnly
                        variant="secondary"
                        onClick={(e) => {
                            e.stopPropagation();
                            setShowState(true);
                        }}
                    >
                        <FontAwesomeIcon icon={faTrashAlt} />
                    </Button>
                </UserfulTooltip>
            )}
            {!hideTrigger && onTheTable && (
                <Dropdown.Item
                    className="dropdownItem"
                    onClick={(e) => {
                        e.stopPropagation();
                        setShowState(true);
                    }}
                >
                    <div className="userful-icon-dropdown-menu-icon-container">
                        <FontAwesomeIcon icon={faTrashAlt} />
                    </div>
                    <p>{t("Shared.delete")}</p>
                </Dropdown.Item>
            )}

            <UserfulConfirmationDialog
                show={showConfirmation}
                icon={{ icon: faCircleExclamation, color: "#D13E2C" }}
                onCancel={() => setShowState(false)}
                title={t("Shared.delete") + " " + t("Shared.workspace")}
                replaceBody={
                    <>
                        <p>
                            {t("Shared.deleteStart")} <strong>{workspace.name}</strong>
                            {"? "}
                            {t("Shared.deleteEnd")}
                        </p>
                    </>
                }
                replaceFooter={
                    <>
                        <Button variant="secondary" onClick={() => setShowState(false)}>
                            {t("Shared.cancel")}
                        </Button>
                        <Button
                            variant="danger"
                            onClick={() => {
                                requestRemoveUConductWorkspace(workspace.id);
                                setShowState(false);
                                onAction?.();
                            }}
                        >
                            {t("Shared.delete")}
                        </Button>
                    </>
                }
            />
        </>
    );
}
